/* eslint-disable max-len */
/* eslint-disable no-unexpected-multiline */
import React, {useEffect, useRef} from 'react'
import {connect} from 'react-redux'
// import Helpers from '../Helpers'
import {storePayload} from '../actions/storePayload'
import workflowResources from '../Workflow_Resources.json'
import {flattenSubSectionQuestions} from '../actions/flattenQuestions'
import {changeQuestion} from '../actions/changeQuestion2'
import SubSection from './SubSection'
import Resources from './Resources'
// import Btn from './Btn'
import {Icon, Button} from '@lazarusai/forms-ui-components'
import '../styles/TypeForm.css'

function TypeForm(props) {
  const {
    prompt1Response,
    selectedSectionIndex,
    selectedSubSectionIndex,
    selectedSectionName,
    selectedSubSectionName,
    localPrompt1Response,
    isSubSectionReadyForReview,
    currentPqId,
    currentPqIdIndex,
    currentUfqId,
    currentUfqIdIndex,
    isReview,
    isResourcesPage,
    // isSkip,
    // eslint-disable-next-line no-unused-vars
    time,
  } = props
  const submitInputRef = useRef()
  const buttonRef = useRef()
  // console.log(
  //     'HERE: ',
  //     localPrompt1Response,
  //     selectedSectionName,
  //     selectedSubSectionName,
  //     currentPqId,
  //     currentUfqId,
  // )
  // const pqData =
  //   prompt1Response?.
  //       [selectedSectionName]?.
  //       [selectedSubSectionName]

  // const pqIds = pqData ? Object.keys(pqData) : []

  // const ufqData =
  //     prompt1Response?.
  //         [selectedSectionName]?.
  //         [selectedSubSectionName]?.
  //         [props.currentPqId || pqIds[0]]?.
  //         ['User Facing Question']

  // Set selectedSection/SubSectionNames if undefined
  // useEffect(() => {
  // eslint-disable-next-line max-len
  //   if (prompt1Response && (!selectedSectionName || !selectedSubSectionName)) {
  //     const newSelectedSectionName =
  //       Object.keys(prompt1Response)[selectedSectionIndex]
  //     const newSelectedSubSectionName =
  //       Object.keys(
  //           prompt1Response[newSelectedSectionName],
  //       )[props.selectedSubSectionIndex]
  //     props.storePayload({
  //       selectedSectionName: newSelectedSectionName,
  //       selectedSubSectionName: newSelectedSubSectionName,
  //     })
  //   }
  // },
  // [
  //   prompt1Response,
  //   selectedSectionName,
  //   selectedSubSectionName,
  //   selectedSectionIndex,
  //   selectedSubSectionIndex,
  // ])
  // useEffect(() => {
  //   if (submitInputRef.current) {
  //     setTimeout(() => {
  //       submitInputRef.current?.focus()
  //     }, [1000])
  //   }
  // }, [submitInputRef, isSubSectionReadyForReview, isReview])

  useEffect(() => {
    if (isReview) {
      setTimeout(() => {
        const questionContainer = document.getElementById('question-container')
        if (questionContainer) {
          questionContainer.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
        }
      }, [1000])
    }
  }, [isReview])

  useEffect(() => {
    const newSubSectionName =
        Object.keys(prompt1Response
            [selectedSectionName],
        )[selectedSubSectionIndex]

    // console.log(
    //     'selected section index',
    //     selectedSectionName,
    //     selectedSectionIndex,
    //     selectedSubSectionName,
    //     'new: ',
    //     newSubSectionName,
    //     selectedSubSectionIndex,
    // )
    if (
      selectedSectionIndex > 0 &&
      selectedSectionIndex !== 2 && // Acquisition Strat handled separately for demo
      (!selectedSubSectionName ||
      newSubSectionName === 'Cover Page')
    ) {
      // console.log('Changing from cover page')
      const changeQuestionProps = {
        newSubSectionIndex: selectedSubSectionIndex + 1,
        // newPqIdIndex: 0,
        // currentPqId,
        currentPqIdIndex: 0,
        currentUfqIdIndex: 0,
        prompt1Response,
        selectedSectionIndex,
        selectedSubSectionIndex,
        selectedSectionName,
        selectedSubSectionName: newSubSectionName,
        isReview: false,
        direction: 'forwards',
        isSubSectionReadyForReview: false,
        isResourcesPage: false,
      }
      console.log('here')
      props.changeQuestion(changeQuestionProps)
    }
  }, [selectedSectionIndex])

  // Delete for prod
  useEffect(() => {
    // Conditional set to trigger this after useEffect that triggers without id's
    if (currentPqId && currentUfqId) {
      // hack for demo to find minor element with resources
      const newSubSectionName =
        Object.keys(prompt1Response
            [selectedSectionName],
        )[selectedSubSectionIndex]
      // Limit Acquisition Stratgey to minor elements with resources
      const minElIndicesWithResources = [5, 8, 9, 16]
      let newSubSecI = selectedSubSectionIndex
      let isSubSectionReadyForReview = false
      if (selectedSectionIndex === 2) { // acquis strat
        for (let i = 0; i < minElIndicesWithResources.length; i ++) {
          const minElI = minElIndicesWithResources[i]
          // const nextMinElI = minElIndicesWithResources[i + 1]
          if (selectedSubSectionIndex === minElI) {
            break
          } else if (selectedSubSectionIndex < minElI) {
            newSubSecI = minElI
            break
          } else if (selectedSectionIndex > minElI) {
            isSubSectionReadyForReview = true
          }
        }
      }
      if (newSubSecI !== selectedSubSectionIndex) {
        console.log('---changing to find resources---')
        const changeQuestionProps = {
          newSubSectionIndex: newSubSecI,
          // newPqIdIndex: 0,
          // currentPqId,
          currentPqIdIndex: 0,
          currentUfqIdIndex: 0,
          prompt1Response,
          selectedSectionIndex,
          selectedSubSectionIndex,
          selectedSectionName,
          selectedSubSectionName: newSubSectionName,
          isReview: false,
          direction: 'forwards',
          isSubSectionReadyForReview,
          isResourcesPage: false,
        }
        props.changeQuestion(changeQuestionProps)
      }
    }
  }, [selectedSubSectionIndex, currentPqId, currentUfqId])
  //

  // useEffect(() => {
  //   console.log('///', workflowResources, selectedSectionName, selectedSubSectionName)
  // }, [selectedSectionName, selectedSubSectionName])

  // useEffect(() => {
  //   if (!props.isSubSectionReadyForReview) {
  //     // setTimeout(() => {
  //     //   selectInput()
  //     // }, [100])
  //     selectInput()
  //   }
  // }, [currentPqId, currentUfqId, isSubSectionReadyForReview])

  // useEffect(() => {
  //   if (localPrompt1Response) {
  //     console.log(
  //         'HERE2: ',
  //         localPrompt1Response
  //             [selectedSectionName]
  //             [selectedSubSectionName]
  //             ['Questions']
  //             [currentPqId]
  //             ['User Facing Question']
  //             [currentUfqId],
  //     )
  //   }
  // }, [localPrompt1Response])

  // function selectInput() {
  //   const {
  //     selectedSectionName,
  //     selectedSubSectionName,
  //     currentPqId,
  //     currentUfqId,
  //   } = props
  //   const identifier = `${selectedSectionName}/${selectedSubSectionName}/${currentPqId}/${currentUfqId}`
  //   const inputId = `input/${identifier}`
  //   // const btnId = `submit-btn/${identifier}`
  //   const newInputEl = document.getElementById(inputId)
  //   const newBtnEl = buttonRef.current
  //   if (newInputEl) {
  //     setTimeout(() => {
  //       newInputEl.focus()
  //       newInputEl.addEventListener('keypress', (e) => {
  //         if (e.key === 'Enter' && !e.shiftKey) {
  //           e.preventDefault()
  //           newBtnEl.click()
  //           // To do; use formId, attach question meta data to find it
  //         }
  //       })
  //     }, [100])
  //   }
  // }

  useEffect(() => {
    const newSelectedSectionName =
      Object.keys(prompt1Response)[selectedSectionIndex]
    const newSelectedSubSectionName =
      Object.keys(prompt1Response[newSelectedSectionName])
          [selectedSubSectionIndex]
    props.storePayload({
      selectedSectionName: newSelectedSectionName,
      selectedSubSectionName: newSelectedSubSectionName,
    })
  }, [prompt1Response, selectedSectionIndex, selectedSubSectionIndex])

  useEffect(() => {
    // get section/subsection names and question id's for new subSection
    if (!currentPqId || !currentUfqId) {
      console.log(
          'Do we at least have names? ',
          selectedSectionName,
          selectedSubSectionName,
      )
      const onChangeQuestionProps = {
        newSubSectionIndex: null,
        newPqIdIndex: null,
        newUfqIdIndex: 0,
        currentPqId,
        currentPqIdIndex: 0,
        currentUfqIdIndex: 0,
        prompt1Response,
        selectedSectionIndex,
        selectedSubSectionIndex,
        selectedSectionName,
        selectedSubSectionName,
        isSubSectionReadyForReview,
        isReview,
        isResourcesPage,
      }
      console.log('here')
      props.changeQuestion(onChangeQuestionProps)
    }
  }, [
    selectedSectionIndex,
    selectedSubSectionIndex,
  ])

  useEffect(() => {
    // create flattened array of questions to map out
    if (selectedSectionName && selectedSubSectionName) {
      const fsqProps = {
        prompt1Response,
        selectedSectionName,
        selectedSectionIndex,
        selectedSubSectionName,
        selectedSubSectionIndex,
      }
      props.flattenSubSectionQuestions(fsqProps)
    }
  }, [
    selectedSectionName,
    selectedSubSectionName,
  ])

  function onChangeAnswer(e, pqId, ufqId) {
    const tempPrompt1Response = prompt1Response
    const tempLocalPrompt1Response = localPrompt1Response
    const currVal = e.target.value
    // Change progress metadata
    const previousVal =
      tempPrompt1Response
          [selectedSectionName]
          [selectedSubSectionName]
          ['Questions']
          [pqId]
          ['User Facing Question']
          [ufqId]
          ['Answer']
    if (previousVal) {
      if (!currVal) {
        tempPrompt1Response
            [selectedSectionName]
            [selectedSubSectionName]
            ['Local Data']
            ['completed'] -= 1
      }
    } else if (currVal) {
      tempPrompt1Response
          [selectedSectionName]
          [selectedSubSectionName]
          ['Local Data']
          ['completed'] += 1
    }
    // Set value on BE data and local copy
    tempPrompt1Response
        [selectedSectionName]
        [selectedSubSectionName]
        ['Questions']
        [pqId]
        ['User Facing Question']
        [ufqId]
        ['Answer'] =
        currVal
    tempLocalPrompt1Response
        [selectedSectionName]
        [selectedSubSectionName]
        ['Questions']
        [pqId]
        ['User Facing Question']
        [ufqId]
        ['Answer'] =
        currVal
    // time is added to trigger rerender to remove button disabled state
    props.storePayload({
      prompt1Response: tempPrompt1Response,
      localPrompt1Response: tempLocalPrompt1Response,
      isSkip: false,
      time: Date.now(),
    })
  }

  function subSectionProgressDecimal() {
    if (
      localPrompt1Response?.
          [selectedSectionName]?.
          [selectedSubSectionName]?.
          ['Local Data']
    ) {
      return (
        localPrompt1Response
            [selectedSectionName]
            [selectedSubSectionName]
            ['Local Data']
            ['completed'] /
        localPrompt1Response
            [selectedSectionName]
            [selectedSubSectionName]
            ['Local Data']
            ['total']
      )
    }
  }

  if (
    localPrompt1Response?.
        [selectedSectionName]?.
        [selectedSubSectionName]?.
        ['Flattened Questions']
  ) {
    return (
      <div
        id='typeform'
        onClick={() => {
          if (props.isChatShowing) {
            props.storePayload({
              isChatShowing: false,
            })
          }
        }}
        className={
          `typeform ${props.isReview ? 'review-typeform' : ''}`
        }
      >
        <span
          id='skip-ahead'
          className='link-btn'
          onClick={() => {
            const lastSubSectionIndex =
              Object.keys(
                  prompt1Response?.
                      [selectedSectionName],
              )?.length - 1
            props.storePayload({
              selectedSubSectionIndex: lastSubSectionIndex,
              isReview: true,
              isSkip: true,
              isSectionReadyForReview: true,
              typeFormStep: 'section-review',
            })
          }}
        >
          Skip Ahead in Demo
        </span>
        <SubSection
          style={
            !props.isReview ?
            {
              position: 'absolute',
              top: '10px',
            } : {}
          }
          number={
            // eslint-disable-next-line max-len
            `${props.selectedSectionIndex + 1}.${props.selectedSubSectionIndex + 1}`
          }
          title={selectedSubSectionName}
          status={subSectionProgressDecimal() === 1 ? 'Complete' : 'Incomplete'}
          completed={
            localPrompt1Response
                [selectedSectionName]
                [selectedSubSectionName]
                ['Local Data']
                ['completed'] || 0
          }
          total={
            localPrompt1Response
                [selectedSectionName]
                [selectedSubSectionName]
                ['Local Data']
                ['total'] || 0
          }
          isSelected={true}
          resources={workflowResources?.[props.selectedSectionName]?.[props.selectedSubSectionName]}
          references={
            localPrompt1Response?.
                [selectedSectionName]?.
                [selectedSubSectionName]?.
                ['Questions']?.
                [currentPqId]?.
                ['User Facing Question']?.
                [currentUfqId]?.
                ['References']
          }
        />
        {/* <a
          href='www.google.com'
          target='_blank'
          rel='noreferrer'
        >
          <Button
            text='CITATION'
            type={1}
            theme={props.theme}
            className='citation-btn'
          />
        </a> */}
        {isResourcesPage ?
        <Resources /> :
        <div
          id='question-container'
          className='question-container'
        >
          {
            props.localPrompt1Response
                [selectedSectionName]
                [selectedSubSectionName]
                ['Flattened Questions']
                .map((ufq, i) => {
                  const questionsLength =
                    props.localPrompt1Response
                        [selectedSectionName]
                        [selectedSubSectionName]
                        ['Flattened Questions']
                        ['length']
                  const {
                    pqId,
                    ufqId,
                    pqIdIndex,
                    // ufqIdIndex,
                    sectionName,
                    // sectionIndex,
                    subSectionName,
                    // subSectionIndex,
                  } = ufq
                  const isLastQ = i === questionsLength - 1
                  const isInView = ufqId === currentUfqId
                  const isLastQInView =
                    isLastQ && isInView
                  if (isLastQInView) {
                    props.storePayload({
                      isLastQInView: true,
                    })
                  } else {
                    props.storePayload({
                      isLastQInView: false,
                    })
                  }
                  const currAnswer =
                    props.prompt1Response?.
                        [selectedSectionName]?.
                        [selectedSubSectionName]?.
                        ['Questions']?.
                        [ufq.pqId]?.
                        ['User Facing Question']?.
                        [ufq.ufqId]?.
                        ['Answer']
                  // const isLastQ =
                  //   i + 1 ===
                  //   props.localPrompt1Response
                  //       [selectedSectionName]
                  //       [selectedSubSectionName]
                  //       ['Flattened Questions']
                  //       ['length']
                  // 'Potential Question in Details'
                  const identifier = `${sectionName}/${subSectionName}/${pqId}/${ufqId}`
                  const formId = `form/${identifier}`
                  // console.log(
                  //     '///HERE///',
                  //     ufqIdIndex,
                  //     currentUfqIdIndex,
                  //     pqIdIndex,
                  //     currentPqIdIndex,
                  // )

                  let className = `typeform-question `
                  if (!isSubSectionReadyForReview) {
                    if (ufqId === currentUfqId) {
                      className += 'question-in'
                    } else if (currentPqIdIndex > pqIdIndex) {
                      className += 'hide-top'
                    } else {
                      className += 'hide-bottom'
                    }
                  } else {
                    className += 'hide-bottom'
                  }
                  return (
                    <div
                      className={className}
                      key={formId}
                    >
                      <div className='typeform-question-number'>
                        <span>{i + 1}</span>
                      </div>
                      <div className='typeform-question-form'>
                        {ufq['Header'] &&
                          <h2>{ufq['Header']}</h2>
                        }
                        <h2
                          className={
                            isReview && !currAnswer?
                            'red-text' :
                            ''
                          }
                        >
                          {ufq['Question']?.replace(/","/gi, ',')}
                        </h2>
                        <form
                          id={formId}
                          onSubmit={(e) => {
                            e.preventDefault()
                            if (isLastQ) {
                              props.storePayload({
                                isSubSectionReadyForReview: true,
                              })
                            } else {
                              const onChangeQuestionProps = {
                                newSubSectionIndex: null,
                                newPqIdIndex: currentPqIdIndex + 1,
                                newUfqIdIndex: currentUfqIdIndex + 1,
                                currentPqId,
                                currentPqIdIndex: currentPqIdIndex,
                                currentUfqIdIndex: currentUfqIdIndex,
                                prompt1Response,
                                selectedSectionIndex,
                                selectedSubSectionIndex,
                                selectedSectionName,
                                selectedSubSectionName,
                                isSubSectionReadyForReview,
                                isReview,
                                isResourcesPage,
                              }
                              // console.log('here')
                              props.changeQuestion(onChangeQuestionProps)
                            }
                          }}
                        >
                          <div className={'text-area-wrapper'}>
                            <div
                              className={'typeform-input invisible-text-area'}
                              id={`invisible-text-area/${sectionName}/${subSectionName}/${pqId}/${ufqId}`}
                            >
                              {currAnswer}
                            </div>
                            <textarea
                              placeholder={'Type your answer here...'}
                              onChange={(e) => {
                                onChangeAnswer(e, pqId, ufqId)
                              }}
                              name='newPrompt'
                              value={currAnswer}
                              rows={1}
                              form={formId}
                              style={
                                currAnswer && isReview ?
                                  {color: 'yellow'} :
                                  {}
                              }
                              className={'typeform-input custom-txt-area'}
                              // eslint-disable-next-line max-len
                              id={`input/${identifier}`}
                            />
                          </div>
                          {isReview && !currAnswer ?
                            <p
                              className='red-text sub-text work-sans'
                            >
                              This section is incomplete. Please enter a response.
                            </p> :
                            <p
                              className='invisible-text sub-text work-sans'
                            >
                              ---------
                            </p>
                          }
                          {/* <Btn
                            style={{
                              width: '16.75em',
                              fontSize: '16px',
                              backgroundColor: 'black',
                            }}
                            text={'OK'}
                            disabled={currAnswer ? false : true}
                            icon={
                              currAnswer ?
                                <Icon
                                  icon='checkmark-outline'
                                  key='okay'
                                /> : ''
                            }
                            form={formId}
                            buttonRef={isInView ? buttonRef : null}
                            buttonType='submit'
                            iconPosition='right'
                            iconJustify='edge'
                            theme={props.theme}
                            className={currAnswer ? 'btn-change' : ''}
                          /> */}
                          <Button
                            style={{
                              width: '16.75em',
                              fontSize: '16px',
                              backgroundColor: 'black',
                              backdropFilter: 'initial',
                            }}
                            text={'OK'}
                            disabled={currAnswer ? false : true}
                            icon={
                              currAnswer ?
                                <Icon
                                  icon='checkmark-outline'
                                  key='okay'
                                /> : ''
                            }
                            form={formId}
                            buttonRef={isInView ? buttonRef : null}
                            buttonType='submit'
                            iconPosition='right'
                            iconJustify='edge'
                            theme={props.theme}
                            className={currAnswer ? 'btn-change' : ''}
                          />
                        </form>
                      </div>
                    </div>
                  )
                })
          }
          {!props.isReview &&
          <div
            className={
              `typeform-question
              ${isSubSectionReadyForReview ?
                'question-in' : 'hide-bottom'}`
            }
            key={'submit-form-container'}
          >
            <div className='typeform-question-number'>
              <Icon
                icon='checkmark-outline'
                key='okay'
              />
            </div>
            <div className='typeform-question-form'>
              <h2 id='section-complete-header'>
                You have completed this section
              </h2>
              <form
                id={'submit-form'}
                onSubmit={(e) => {
                  e.preventDefault()
                  props.storePayload({
                    isReview: true,
                  })
                }}
              >
                <input
                  id='review-input'
                  form='submit-form'
                  style={{opacity: 0}}
                  ref={submitInputRef}
                />
                {/* <Btn
                  style={{width: '16.75em', fontSize: '16px'}}
                  text={'Review'}
                  disabled={false}
                  icon={
                    <Icon
                      icon='checkmark-outline'
                      key='review-check-mark'
                    />
                  }
                  form={'submit-form'}
                  buttonType='submit'
                  iconPosition='right'
                  iconJustify='edge'
                  theme={props.theme}
                  className={'btn-change'}
                /> */}
                <Button
                  style={{
                    width: '16.75em',
                    fontSize: '16px',
                    backdropFilter: 'initial',
                  }}
                  text={'Review'}
                  disabled={false}
                  icon={
                    <Icon
                      icon='checkmark-outline'
                      key='review-check-mark'
                    />
                  }
                  form={'submit-form'}
                  buttonType='submit'
                  iconPosition='right'
                  iconJustify='edge'
                  theme={props.theme}
                  className={'btn-change'}
                />
              </form>
            </div>
          </div>
          }
        </div>
        }
      </div>
    )
  } else {
    return <></>
  }
}

const mapStateToProps = (state) => ({
  theme: state.userReducer.theme,
  selectedSectionIndex: state.userReducer.selectedSectionIndex,
  selectedSectionName: state.userReducer.selectedSectionName,
  selectedSubSectionIndex: state.userReducer.selectedSubSectionIndex,
  selectedSubSectionName: state.userReducer.selectedSubSectionName,
  selectedPath: state.userReducer.selectedPath,
  prompt1Response: state.userReducer.prompt1Response,
  currentPqId: state.userReducer.currentPqId,
  currentUfqId: state.userReducer.currentUfqId,
  currentPqIdIndex: state.userReducer.currentPqIdIndex,
  currentUfqIdIndex: state.userReducer.currentUfqIdIndex,
  time: state.userReducer.time,
  localPrompt1Response: state.userReducer.localPrompt1Response,
  isSubSectionReadyForReview: state.userReducer.isSubSectionReadyForReview,
  isChatShowing: state.userReducer.isChatShowing,
  isReview: state.userReducer.isReview,
  isSkip: state.userReducer.isSkip,
  isResourcesPage: state.userReducer.isResourcesPage,
})

export default connect(
    mapStateToProps,
    {storePayload, changeQuestion, flattenSubSectionQuestions},
)(TypeForm)
